//Author June Leow
//Date June 12th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, deleteAPICallGenerator, callBackGenerator, showMessage, formatDateTime} from '../../util/util';
import {Card, CardHeader, CardBody, Row, Col} from 'reactstrap';
import {NavLink, useParams} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {
  conditionComment:'',
  declineReasons:[],
  declineReason:'',
  conditionReasons:[],
  conditionreason:'',
  conditionFee:'',
  conditionTurntime:'',
  declineComment:'',
  conditionPopUp:false,
  declinePopUp:false,
  appraisal:{
    reference_num:'',
    property_street:'',
    property_city:'',
    property_state:'',
    property_zip:'',
    loan_num:'',
    loan_purpose:'',
    loan_type:'',
    datetime_submitted:'0000-00-00',
    status:'',
    borrower_f_name:'',
    borrower_l_name:'',
  },
  valid: false,
};

//reducer function that perform state update
const reducer = getReducer();


const Accept  = (props)=>{
  const controller = new AbortController();

  let id = useParams().id;
  let appraiserFk = useParams().appraiserFk;
  let newInitialState = Object.assign({}, initialState, {
    id:id,
    appraiserFk:appraiserFk
  });

  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);
  const httpGetNoToken = getAPICallGenerator(props, {signal:controller.signal, noToken:true});
  const httpPostNoToken = postAPICallGenerator(props, {signal:controller.signal, noToken:true});

  //run only once when component is loaded
  useEffect(()=>{
    getAppraisal();
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state

  //API call
  const getAppraisal=()=>{
    let callBack = (response)=>{console.log(response);
      let code = response.data.code;
      if(code==='00'){
        setState({appraisal:response.data.data});

        if(response.data.data.status==='Assigned'&&response.data.data.appraiser_fk ===state.appraiserFk){
          setState({valid:true});
          setAcceptance('yes');
        }
        else{
          showMessage('error', 'This link is expired, please contact service@homevms.com for assistance.');
        }
      }
    };
    httpGetNoToken('appraisal/public/'+state.id, '', 'Oops, something went wrong and could not load the appraisal information. Please try again later.', callBack);
  }

  const setAcceptance=(action)=>{
    let parameters = [
      {
        field:'orderID',
        value:state.id
      },
      {
        field:'appraiserFk',
        value:state.appraiserFk
      },
      {
        field:'action',
        value:action
      }
    ];


    let callBack = (response)=>{
      let code = response.data.code;

      if(code==='00'){
        setState({valid:false});
      }
    };
    httpPostNoToken('appraisal/assignment/noSession/acceptance', parameters, 'Assignment accepted successfully.','Oops, something went wrong and could not accept the assignment. Please try again later.', callBack);
  }

  //render
  let action;
  if(!state.valid&&state.appraisal.reference_num!==''){
    if(state.appraisal.appraiser_fk!==state.appraiserFk){
      action = <center>
        The assignment acceptance link is expired, please reach out to us about the order status.
      </center>
    }
    else{
      action = <center>
        This order had been accepted/declined.
      </center>
    }
  }
  else {
    action = <center>
      The assignment acceptance link is expired, please reach out to us about the order status.
    </center>
  }

  let topBar;
  console.log(props);
  if(!props.isLoggedIn){
    topBar = <div className="topbar">
        <div className="topbar-logo-container">
          <NavLink to="/"><img className="topbar-logo-img" alt="@Home VMS Logo" width="120px" src="/img/logo_small.png"/></NavLink>
        </div>
    </div>;
  }

  return (
    <div>
      {topBar}

      <div className="padding">
        <Row>
          <Col sm="1">

          </Col>
          <Col sm="10">
            <Card style={{background:'#f5f5f5'}}>
              <CardHeader className="header-color">
                <center>
                    <i className="fa fa-edit"></i> Appraisal acceptance
                </center>
              </CardHeader>
              <CardBody>
                <div style={{background:'white', border:'1px solid #d2d2d2',padding:'5px',borderRadius:'5px'}}>
                  <label>Reference #:&nbsp;&nbsp;</label>
                  {state.appraisal.reference_num}

                  <br/>
                  <label>Status:&nbsp;&nbsp;</label>
                  {state.appraisal.status}

                  <br/>
                  <label>Property address:&nbsp;&nbsp;</label>
                  {state.appraisal.property_street+' '+state.appraisal.property_city+', '+state.appraisal.property_state+' '+state.appraisal.property_zip}

                  <br/>
                  <label>Borrower:&nbsp;&nbsp;</label>
                  {state.appraisal.borrower_f_name+' '+state.appraisal.borrower_l_name}

                  <br/>
                  <label>Loan purpose:&nbsp;&nbsp;</label>
                  {state.appraisal.loan_purpose}

                  <br/>
                  <label>Loan type:&nbsp;&nbsp;</label>
                  {state.appraisal.loan_type}

                  <br/>
                  <label>Loan #:&nbsp;&nbsp;</label>
                  {state.appraisal.loan_num}

                  <br/>
                  <label>Date submitted:&nbsp;&nbsp;</label>
                  {formatDateTime(state.appraisal.datetime_submitted)}

                  <br/>
                </div>
                <br/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}


export default Accept;
